// @ts-strict-ignore
import { QueryKey } from 'constants/query-key';
import { OnboardingEventStepCompletedType, ONBOARDING_EVENT_STEP_COMPLETED } from 'hooks/api/onboarding/constants';
import { handleOnboardingStepSuccess } from 'hooks/api/onboarding/helpers';
import { completeOnboardingStepRequest, handleError } from 'hooks/api/onboarding/use-complete-onboarding-step';
import { type IProductOnboardingProgress, type ProductOnboardingStep } from 'interfaces/entities/product-onboarding';
import { getQueryClient } from 'services/query-client/client';

const getIsStepCompleted = (stepName: ProductOnboardingStep): boolean => {
  const queryClient = getQueryClient();
  const onboardingProgress = queryClient.getQueryData<IProductOnboardingProgress>([QueryKey.OnboardingProgress]);

  return onboardingProgress?.[stepName] ?? true;
};

export async function markOnboardingStepComplete(step: ProductOnboardingStep): Promise<void> {
  if (getIsStepCompleted(step)) {
    return;
  }

  try {
    await completeOnboardingStepRequest({ step });
    await handleOnboardingStepSuccess({
      step,
      eventName: ONBOARDING_EVENT_STEP_COMPLETED,
      eventType: OnboardingEventStepCompletedType.ManuallyCompleted,
    });
  } catch (error) {
    handleError(error);
  }
}
